import type { I18N_IOverrideDict } from '../I18N/I18N.overrides'
import { IDB_dictReadAll, IDB_dictWrite, IDB_rowsDelete } from './IDB.queries'
import { IDB_globalDb } from './IDB'

export function IDB_languageOverridesDelete(paths: string[]) {
    return IDB_rowsDelete(IDB_globalDb, 'language_overrides', paths)
}

export function IDB_languageOverridesReadAll() {
    return IDB_dictReadAll<string>(IDB_globalDb, 'language_overrides')
}

export function IDB_languageOverridesWrite(languageOverrides: I18N_IOverrideDict) {
    return IDB_dictWrite(IDB_globalDb, 'language_overrides', languageOverrides)
}
